import React, {
} from 'react';
import {DataGrid} from '@material-ui/data-grid';
import AuditLogRepository from "../../../repositories/AuditLogRepository";
import Header from "./Header";
import {useGrid} from "../../../hooks/crud/Grid";
import {useTranslation} from "react-i18next";
import {GridSkeleton} from "../../../components/GridSkeleton";
import StaticClassifierRepository from "../../../repositories/StaticClassifierRepository";

const VerificationStatusView = () => {

	const repository = new AuditLogRepository();
	const {t}  = useTranslation();

	const sortOptions = [
      {
        value: 'Id|desc',
        label: t('Newest first')
      },
      {
        value: 'Id|asc',
        label: t('Oldest first')
      }
    ];

	const repoMethod = async (x) => await repository.getVerificationStatuses(x);
	const classifierRepository = new StaticClassifierRepository();

    const mapAuditEventType = (id) => {
        return classifierRepository.getAuditEventTypeNameById(id);
    }

	const {items, totalCount, itemsOnPage, onPage, isSearching, updateGrid } = useGrid(repoMethod , { onEdit: null, defaultSort: sortOptions[0].value });

	const columns = [
      { field: 'CreatedAt', type: "dateTime",  headerName: t('Event date'), sortable: false, width: 180 },
      { field: 'AuditEvent', headerName: t('Event type'), width: 400, sortable: false,
          renderCell: ({ value }) => {
              return mapAuditEventType(value);
          }
      }
    ];

	return (
	    <GridSkeleton title={t("Audit log")}
                      isSearching={isSearching}
                      header={(<Header onRefresh={updateGrid} />)}
                      grid={(<DataGrid
                                   disableMultipleSelection={true}
                                   disableColumnFilter
                                   rows={items()}
                                   rowCount={totalCount()}
                                   columns={columns}
                                   pageSize={itemsOnPage}
                                   paginationMode="server"
                                   sortingMode="server"
                                   disableColumnSelector={true}
                                   disableSelectionOnClick={true}
                                   disableColumnMenu={true}
                                   onPageChange={onPage}
                                   rowsPerPageOptions={[itemsOnPage]}
                                   hideFooterSelectedRowCount={true}
                         />)}
        />

	);
};

export default VerificationStatusView;